import { RootState } from "../store";

export const selectGamesLoading = (state: RootState) => state.games.gamesLoading;
export const selectGames = (state: RootState) => state.games.games;
export const selectAppliedGames = (state: RootState) => state.games.appliedGames;
export const selectCreatedGames = (state: RootState) => state.games.createdGames;
export const selectApplicationsCount = (state: RootState) => state.games.applicationsCount;
